import { wccModules } from "enums/wccModules";
import { getStatusText } from "helpers/people";
import { inject, injectable } from "inversify";
import { Subscribable } from "knockout";
import { IWCCStorageManager } from 'managers/iStorage';
import SimpleTopicManager from 'managers/simpleTopic';
import { Person } from "models/person";
import { SimpleTopic } from "models/simpleTopic";
import { PersonAvatarVMConfig } from "../../avatar/person/person";
import { UserContentFormConfig } from "./base.interfaces";

components.preload('person-avatar');

@injectable()
export default class UserContentFormVM {
    topicId: Subscribable<string | undefined>
    person: Subscribable<Person | undefined>

    name = ko.pureComputed(() => this.person()?.nicknameOrName());
    status = ko.pureComputed(() => this.getPersonStatus(this.person()));

    simpleTopic: Subscribable<SimpleTopic | undefined>

    avatarConfig: PersonAvatarVMConfig

    constructor(
        @inject(wccModules.componentConfig) model: UserContentFormConfig,
        @inject(wccModules.storage) storage: IWCCStorageManager
    ) {
        this.topicId = ko.pureComputed(() => ko.unwrap(model.topicId));
        this.person = ko.pureComputed(() => ko.unwrap(model.person));

        const simpleTopicManager = storage.get(SimpleTopicManager, { topicId: this.topicId });
        this.simpleTopic = simpleTopicManager.pluck('topic');

        this.avatarConfig = { person: this.person }
    }

    private getPersonStatus(person?: Person) {
        if (person) {
            const status = getStatusText(person);

            if (status)
                return `(${status})`;
        }
    }
}